import React from "react";
import styles from "./report.module.css";

export default function StatCard({
  title,
  value,
  icon,
  checkIcon,
  checkColor,
  gradientFrom,
  height,
  fontTitle,
  fontValue,
  color,
  isCompare, 
  compare,
  previousData,
  previousIcon,
  unit = "",
  gradientTo,
  iconBackGroundColor 
  // is3Color,
  // gradientVia
}) {
return (
    <div
      className={styles.statCard}
      style={{
        "--from": gradientFrom,
        "--to": gradientTo,
        height: height,
        color: color
      }}
    >
      <div className={styles.iconWrapper} style={{backgroundColor: iconBackGroundColor}}>{icon}</div>

      <div className={styles.cardTitle} style={{ fontSize: fontTitle }}>
        {title}
      </div>

      <div className="d-flex align-items-end">
        <div className={styles.cardValue} style={{ fontSize: fontValue }}>
          {value} {unit}
        </div>
        <div className={styles.previousData}>
          {previousIcon} {previousData}
        </div>
      </div>

      {isCompare && (
        <div className={styles.compare}>
          {checkIcon}
          <span
            className="mr-2"
            style={{
              fontSize: 15,
              color: checkColor,
              fontWeight: "bold"
            }}
          >
            {compare}%
          </span>
          vs last month
        </div>
      )}
    </div>
  );
}


